import { MultilingualKeyDto } from '../types/MultilingualKeyDto'

export const getMultilingualKey = (o: MultilingualKeyDto, language?: string) => {
  if (language === 'sv' && o.sv) return o.sv
  if (language === 'en' && o.en) return o.en

  return o.fi ?? ''
}
